import React from "react";


import {IconBox, IconProps, IconSize} from "./index";

export type MarkAsReadIconProps = IconProps & {
    className?: string;
    size?: IconSize;
}
import MarkAsReadSvg from "../../../assets/icons/mark_as_read.svg?react";


export const MarkAsReadIcon = React.forwardRef<HTMLElement, MarkAsReadIconProps>(
    ({
         className,
         size = 24,
         ...rest
     }: MarkAsReadIconProps, ref) => {
        return (
            <IconBox
                {...rest}
                ref={ref}
                className={className}
                size={size}
            >
                <MarkAsReadSvg/>
            </IconBox>
        );
    }
);